module.exports = __webpack_public_path__ + "img/plat_4961.f9802862.jpg";